import { Themed } from "@components/atoms/Themed"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-seo-landing", (props) => {
  return (
    <Themed
      page
      theme={props.seoLanding?.pageTheme}
      footer
      footerTheme={props.seoLanding?.footerTheme}
      className="w-full"
    >
      <ContentBlocks blocks={props.seoLanding.contentBlocks} />
    </Themed>
  )
})
